<template>
    <b-col sm="12" md="2" class="dashboard-card-col">
        <b-card
            @mouseover="isHovering = true"
            @mouseout="isHovering = false"
            class="icon-button dashboard-card"
        >
            <div class="text-muted text-center mb-3">
                <p>
                    <span class="fa-stack fa-4x" v-if="mostrarQtd && loading">
                        <i
                            :class="{
                                'fa fa-circle fa-stack-2x': true,
                                'text-primary': isHovering
                            }"
                        ></i>
                        <i :class="`fa ${icon} fa-stack-1x fa-inverse`"></i>
                        <span class="badge loading-dash">
                            <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                        </span>
                    </span>
                    <span
                        class="fa-stack fa-4x has-badge"
                        :data-count="qtd"
                        v-if="mostrarQtd && !loading"
                    >
                        <i
                            :class="{
                                'fa fa-circle fa-stack-2x': true,
                                'text-primary': isHovering
                            }"
                        ></i>
                        <i :class="`fa ${icon} fa-stack-1x fa-inverse`"></i>
                    </span>
                    <span class="fa-stack fa-4x has-badge" v-if="!mostrarQtd">
                        <i
                            :class="{
                                'fa fa-circle fa-stack-2x': true,
                                'text-primary': isHovering
                            }"
                        ></i>
                        <i :class="`fa ${icon} fa-stack-1x fa-inverse`"></i>
                    </span>
                </p>
            </div>
            <div class="h5 text-center mb-0 dashboard-card-title">{{ titulo }}</div>
            <div class="text-center text-small" v-if="subTitulo">
                <b-badge variant="primary">{{ subTitulo }}</b-badge>
            </div>
        </b-card>
    </b-col>
</template>

<script>
export default {
    props: {
        icon: {
            type: String
        },

        titulo: {
            type: String
        },

        subTitulo: {
            type: String
        },

        qtd: {
            type: Number,
            default: 0
        },

        mostrarQtd: {
            type: Boolean,
            default: false
        },

        loading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isHovering: false
        }
    }
}
</script>

<style>
.fa-stack[data-count]:after {
    position: absolute;
    right: 0%;
    top: 1%;
    content: attr(data-count);
    font-size: 30%;
    padding: 0.6em;
    border-radius: 999px;
    line-height: 0.75em;
    color: white;
    background: rgba(4, 0, 255, 1);
    text-align: center;
    min-width: 2em;
    font-weight: bold;
}

.loading-dash {
    position: absolute;
    right: 0%;
    top: 1%;
    font-size: 30%;
    padding: 0.4em;
    border-radius: 999px;
    line-height: 0.75em;
    color: white;
    background: rgba(4, 0, 255, 1);
    text-align: center;
    min-width: 2em;
    font-weight: bold;
}

.center-things {
    height: 100%;
    top: 50%;
    position: relative;
}

.center-things p {
    margin: 0;
    background: none;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
}

.dashboard-card-col {
    display: flex;
    margin-bottom: 1rem;
}

.dashboard-card {
    width: 100%;
    height: 100%;
}

.dashboard-card .card-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.dashboard-card-title {
    min-height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1.2;
}
</style>
